import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import joinDiscord from '../../Assets/Images/joinDiscord.png';
import { colors } from '../../theme/helpers';
import Socials from '../Footer/Socials';

const LargeScreenFooter = ({ className }) => (
  <footer className={className}>
    <div className="left__container">
      <h3>Adopte un villageois</h3>
      <div className="informations__container">
        <div className="informations">
          <span>Informations</span>
          <ul>
            <li>
              À propos
            </li>
          </ul>
        </div>
        <div className="socials__container">
          <span>
            Retrouve-nous sur les
            <br /> réseaux sociaux
          </span>
          <div className="socials">
            <Socials />
          </div>
        </div>
      </div>
    </div>
  </footer>
);

LargeScreenFooter.propTypes = { className: PropTypes.string.isRequired };

export default styled(LargeScreenFooter)`
  display: flex;
  font-size: 1rem;
  font-weight: bold;
  padding: 1.5rem;
  height: 375px;
  margin-bottom: 8vh;

  .left__container {
    width: 50%;
    background-image: linear-gradient(
      0deg,
      ${colors.accentGreyTen},
      ${colors.accentGreyTen}
    );
    background-repeat: repeat;
    border-radius: 1.5rem;
    margin: 1rem;

    h3 {
      margin: 1rem;
    }
  }
  .informations__container {
    display: flex;
    justify-content: space-between;
  }
  .informations {
    display: flex;
    flex-direction: column;
    margin: 2rem;
    ul {
      list-style: none;
      padding: 0;
    }
  }
  .socials__container {
    display: flex;
    flex-direction: column;
    margin: 2rem;
    span {
      text-align: center;
    }
  }

  .socials {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
    padding: 10px;
  }

  .right__container {
    width: 50%;
    border-radius: 1.5rem;
    margin: 1rem;
    object-fit: contain;
  }
`;
